import React, {useState,useEffect} from 'react'
import  {DappMenuSreen}  from '../UI/DappMenuSreen';
import detectEthereumProvider from '@metamask/detect-provider'

import link from 'next/link';
import {Wallet_model} from '../../models/Wallet_model';

import Button from '@mui/material/Button';

import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import { useHistory } from "react-router-dom";


export const DappMainScreen = () => {

    const history = useHistory();

    const {web3Loading, getweb3} = Wallet_model();
    const [myWeb3, setMyWeb3] = useState ();

    const [account, setAccount] = useState("");


    const connectWallet = async(event) => {

        localStorage.setItem("red",event);
        await getweb3 (event). then ((response) => {
            setMyWeb3 (response);
            console.log(setMyWeb3(response));
            response.eth.getAccounts (). then ((result) => (
            console.log (result),
            setAccount(result),
            localStorage.setItem("wallet",result[0]),
            setTimeout(() => {
                
    history.push("/dapp/profile");
            }, 2000)
            
            ));
            
        });
    }

    


   

   
    
    return (

        <div className="dapp_container">
          
        
        <div className="dapp__center_columns">

        {account && 
     <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={true}
      >
        <CircularProgress color="inherit" /> <hr></hr>
        <br></br>
        <h3>Bienvenido a Emyto</h3>
      </Backdrop>
            
        }

        <h1>Conectarse con</h1>
            
            {account || web3Loading?      
            <Button type="submit" variant="contained" className="dapp__connected"  disabled>
                                Connect
                                </Button> 
                                :
                                 <Button type="submit" className="dapp__connected" variant="outlined"  onClick = { () =>  connectWallet("ropsten")} >
                                  Ropsten <img style={{"width":"50px"}} src="../assets/rop.png"></img>
                                </Button>

                                
            }


                                <Button type="submit" className="dapp__connected" variant="outlined"  onClick = {() =>  connectWallet("polygon")} >
                                  Polygon <img style={{"width":"50px"}} src="../assets/poly.svg"></img>
                                </Button>


                                <Button type="submit" className="dapp__connected" variant="outlined"  onClick = {() =>  connectWallet("xdai")} >
                                  Xdai <img style={{"width":"50px"}} src="../assets/xdai.png"></img>
                                </Button>



                                <Button type="submit" className="dapp__connected" variant="outlined"  onClick = {() =>  connectWallet("binance")} >
                                  Binance <img style={{"width":"50px"}} src="../assets/binance.png"></img>
                                </Button>



<Button type="submit" className="dapp__connected" variant="outlined"  onClick = {() =>  connectWallet("mainnet")} >
 ethereum <img style={{"width":"50px"}} src="../assets/rop.png"></img>
                                </Button>



        

        </div>
            
        </div>
    )
}
